import React from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonDelete, ButtonEdit } from '../../../../utils/Button';
import { GetNumberWithZero } from '../../../../utils/NumberFormatter';
import { GetDate } from '../../../../utils/Show';
import { handleDeleteSubscriptionsFeaturesOpe } from '../SubscriptionsDetailsOpe';
import { useSubscriptionsDetails } from '../SubscriptionsDetailsProvider';

function FeatureTr({ item }) {
    const { handleFeatureEditModal, handleReload } = useSubscriptionsDetails();
    const { setMessage, setConfirm } = useTemplate();
    const handleDeleteFeatureOpe = (data) => {
        handleDeleteSubscriptionsFeaturesOpe(data?.id)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                setConfirm(null);
                handleReload();
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    const handleDeleteFeature = (data) => {
        setConfirm({
            text: 'Are you sure you want to delete this feature?',
            textAction: 'Delete',
            clickAction: () => {
                handleDeleteFeatureOpe(data);
            }
        });
    };

    return (
        <tr className="border-b border-[#1B1B1F]/10 h-[50px]">
            <td className="!pl-5">{GetNumberWithZero(item?.id)}</td>
            <td>{item?.featureName}</td>
            <td>{item?.featureDescription}</td>
            <td>{GetDate(item?.timeDeployed)}</td>
            <td
                className={`capitalize ${
                    item?.status === 'active' ? '!text-success' : '!text-warning'
                }`}
            >
                {item?.status}
            </td>
            <td className="text-center !pr-5">
                <span>
                    <div className="flex flex-row w-full justify-end gap-1">
                        <ButtonEdit onClick={() => handleFeatureEditModal(item)} />
                        <ButtonDelete onClick={() => handleDeleteFeature(item)} />
                    </div>
                </span>
            </td>
        </tr>
    );
}

function TableHeader() {
    return (
        <thead>
            <tr className="text-primary cursor-default">
                <th scope="col" width="8%" className="rounded-l-xl text-left !pl-5">
                    SL
                </th>
                <th scope="col" width="16%">
                    Title
                </th>
                <th scope="col" width="">
                    Description
                </th>
                <th scope="col" width="18%">
                    Deployment Date
                </th>
                <th scope="col" width="8%">
                    Status
                </th>
                <th
                    scope="col"
                    width="15%"
                    className="rounded-r-xl text-right !pr-5 after:!content-none"
                >
                    Action
                </th>
            </tr>
        </thead>
    );
}

function ViewSubscriptionsFeatureModal({ features }) {
    if (features?.length === 0)
        return (
            <div className="w-full">
                <table className="bik-table">
                    <tbody>
                        <tr>
                            <td colSpan={6}>No Features</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );

    return (
        <div className="w-full">
            <table className="bik-table">
                <TableHeader />
                <tbody>
                    {features?.map((item) => (
                        <FeatureTr key={item?.id} item={item} />
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ViewSubscriptionsFeatureModal;
